import React, { useState, useEffect, useRef } from 'react';
import { CaratIcon } from '@/assets/svgExports/CaratIcon';

const CustomDropDown = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { menus, selected, onChange, className, style } = props;
  const [isDropdownHovered, setIsDropdownHovered] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const dropdownRef = useRef(null);

  const handleSelect = (value) => {
    onChange({ target: { value } });
    setIsMenuOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflowY = 'hidden';
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.pointerEvents = 'none';
      dropdownRef.current.style.pointerEvents = 'auto'; // Enable pointer events only for the dropdown
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.pointerEvents = 'auto'; // Re-enable pointer events when dropdown is closed
      document.body.style.overflowY = 'scroll';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.pointerEvents = 'auto';
    };
  }, [isMenuOpen]);

  function getDefaultValue() {
    const selectedOption = menus.find((item) => item.value === selected);
    if (!selectedOption?.available) {
      const trimmedText =
        selectedOption?.text?.length > 40
          ? `${selectedOption?.text?.substring(0, 40)}...`
          : selectedOption?.text;
      return <span className="tw-text-[#999999]">{`${trimmedText} (Out of stock)`}</span>;
    }
    return <span>{selectedOption?.text}</span>;
  }

  return (
    <div ref={dropdownRef} className={`tw-max-w-[500px] ${className}`} style={style}>
      <div
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="dropdown-header tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-border tw-border-solid tw-border-[#d5d5d5] tw-px-[16px] tw-py-[11.5px] tw-text-sm tw-font-normal"
        style={{
          borderRadius: props?.borderRadius || 0,
          borderColor:
            isDropdownHovered && !isMenuOpen
              ? props?.storeThemeColor || '#d5d5d5'
              : '#d5d5d5',
        }}
        onMouseEnter={() => setIsDropdownHovered(true)}
        onMouseLeave={() => setIsDropdownHovered(false)}
      >
        {getDefaultValue()}
        <CaratIcon
          style={{
            transform: isMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
          }}
        />
      </div>
      {isMenuOpen && (
        <div
          className="dropdown-menu tw-absolute tw-z-10 tw-mt-[6px] tw-max-h-[200px] tw-w-full tw-max-w-[500px] tw-overflow-y-auto tw-border tw-border-solid tw-border-[#e9e9e9] tw-bg-white"
          style={{
            borderRadius: props?.borderRadius !== '0px' ? 12 : 0,
            boxShadow: '2px 2px 4px 0px #0000001A',
          }}
        >
          {menus.map(({ value, text, visible, available }, index) =>
            visible ? (
              <div
                key={index}
                onClick={() => handleSelect(value)}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className="dropdown-item tw-z-10 tw-px-[16px] tw-py-[11px] tw-text-sm tw-font-normal"
                style={{
                  borderBottom: index !== menus.length - 1 ? '1px solid #E9E9E9' : 'none',
                  color: available ? '#000' : '#999999',
                  backgroundColor:
                    value === selected || index === hoveredIndex ? '#F7F7F7' : '#fff',
                  cursor: available ? 'pointer' : 'default',
                }}
              >
                {text ?? value}
              </div>
            ) : null
          )}
        </div>
      )}
    </div>
  );
};

export default CustomDropDown;
